// Module
var code = "<div id=\"V-B2CABD0B-CD54-4D2F-82AE-78B783996770\"> <div data-b-component=\"input\" class=\"input\" data-b-comp-text=\"{Binding value}\"></div> </div> ";
// Exports
export default code;